import { Box, Grid } from "@mui/material";
import LogoCardSkeleton from "./LogoCardSkeleton";

export const Spinner = ({ msg }: { msg: string }) => {
  return (
    <Grid container spacing={2} fontFamily={"Montserrat"}>
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: "5%" }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          height="100vh"
        >
          <LogoCardSkeleton />
         
        </Box>
      </Grid>
    </Grid>
  );
};
